/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B030010 請求締処理
 */
import { Box } from "@mui/material";
import {
  B000140UrikakeshainNm,
  B000150SeikyuNmr1,
  B000150SeikyuNmr10,
  B000150SeikyuNmr11,
  B000150SeikyuNmr12,
  B000150SeikyuNmr13,
  B000150SeikyuNmr14,
  B000150SeikyuNmr15,
  B000150SeikyuNmr16,
  B000150SeikyuNmr17,
  B000150SeikyuNmr18,
  B000150SeikyuNmr19,
  B000150SeikyuNmr2,
  B000150SeikyuNmr20,
  B000150SeikyuNmr3,
  B000150SeikyuNmr4,
  B000150SeikyuNmr5,
  B000150SeikyuNmr6,
  B000150SeikyuNmr7,
  B000150SeikyuNmr8,
  B000150SeikyuNmr9,
  B000150SeikyuNmrFrom1,
  B000150SeikyuNmrFrom2,
  B000150SeikyuNmrFrom3,
  B000150SeikyuNmrFrom4,
  B000150SeikyuNmrTo1,
  B000150SeikyuNmrTo2,
  B000150SeikyuNmrTo3,
  B000150SeikyuNmrTo4,
  B030010Create,
  B030010CreateRequest,
  B030010Find,
  B030010FindRequest,
  B030010FindResponse,
  B030010Update,
  B030010UpdateRequest,
  B030020GetSeikyujokenResponse,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { getSCode, SCode, SeikyujokenKbn } from "messages/codes";
import { labels } from "messages/labels";
import { B000140, B000150 } from "pages";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { calledParam, seikyujokenKbn } from "services/codes";
import { focusState, useFocus } from "states";

export type B030010InputData = {
  editKbn: string;
  seikyu: B030020GetSeikyujokenResponse;
};

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  seikyuYmd: string;
  seikyushimeYmd: string;
  nyukinYmd: string;
  urikakeshainCd: string;
  urikakeshainNm: string;
  seikyujokenKbn: SCode;
  seikyuCdFrom1: string;
  seikyushitenCdFrom1: string;
  seikyuNmrFrom1: string;
  seikyuCdTo1: string;
  seikyushitenCdTo1: string;
  seikyuNmrTo1: string;
  seikyuCdFrom2: string;
  seikyushitenCdFrom2: string;
  seikyuNmrFrom2: string;
  seikyuCdTo2: string;
  seikyushitenCdTo2: string;
  seikyuNmrTo2: string;
  seikyuCdFrom3: string;
  seikyushitenCdFrom3: string;
  seikyuNmrFrom3: string;
  seikyuCdTo3: string;
  seikyushitenCdTo3: string;
  seikyuNmrTo3: string;
  seikyuCdFrom4: string;
  seikyushitenCdFrom4: string;
  seikyuNmrFrom4: string;
  seikyuCdTo4: string;
  seikyushitenCdTo4: string;
  seikyuNmrTo4: string;
  seikyuCd1: string;
  seikyushitenCd1: string;
  seikyuNmr1: string;
  seikyuCd2: string;
  seikyushitenCd2: string;
  seikyuNmr2: string;
  seikyuCd3: string;
  seikyushitenCd3: string;
  seikyuNmr3: string;
  seikyuCd4: string;
  seikyushitenCd4: string;
  seikyuNmr4: string;
  seikyuCd5: string;
  seikyushitenCd5: string;
  seikyuNmr5: string;
  seikyuCd6: string;
  seikyushitenCd6: string;
  seikyuNmr6: string;
  seikyuCd7: string;
  seikyushitenCd7: string;
  seikyuNmr7: string;
  seikyuCd8: string;
  seikyushitenCd8: string;
  seikyuNmr8: string;
  seikyuCd9: string;
  seikyushitenCd9: string;
  seikyuNmr9: string;
  seikyuCd10: string;
  seikyushitenCd10: string;
  seikyuNmr10: string;
  seikyuCd11: string;
  seikyushitenCd11: string;
  seikyuNmr11: string;
  seikyuCd12: string;
  seikyushitenCd12: string;
  seikyuNmr12: string;
  seikyuCd13: string;
  seikyushitenCd13: string;
  seikyuNmr13: string;
  seikyuCd14: string;
  seikyushitenCd14: string;
  seikyuNmr14: string;
  seikyuCd15: string;
  seikyushitenCd15: string;
  seikyuNmr15: string;
  seikyuCd16: string;
  seikyushitenCd16: string;
  seikyuNmr16: string;
  seikyuCd17: string;
  seikyushitenCd17: string;
  seikyuNmr17: string;
  seikyuCd18: string;
  seikyushitenCd18: string;
  seikyuNmr18: string;
  seikyuCd19: string;
  seikyushitenCd19: string;
  seikyuNmr19: string;
  seikyuCd20: string;
  seikyushitenCd20: string;
  seikyuNmr20: string;
  taishoseikyuKensu: string;
  taishouridenpyoKensu: string;
  taishonyukindenpyoKensu: string;
  seikyushimeNo: string;
  seikyushimeshoriKbn: number;
  seikyushimeStatus: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  seikyuYmd: "",
  seikyushimeYmd: "",
  nyukinYmd: "",
  urikakeshainCd: "",
  urikakeshainNm: "",
  seikyujokenKbn: getSCode(SeikyujokenKbn, "9"),
  seikyuCdFrom1: "",
  seikyushitenCdFrom1: "",
  seikyuNmrFrom1: "",
  seikyuCdTo1: "",
  seikyushitenCdTo1: "",
  seikyuNmrTo1: "",
  seikyuCdFrom2: "",
  seikyushitenCdFrom2: "",
  seikyuNmrFrom2: "",
  seikyuCdTo2: "",
  seikyushitenCdTo2: "",
  seikyuNmrTo2: "",
  seikyuCdFrom3: "",
  seikyushitenCdFrom3: "",
  seikyuNmrFrom3: "",
  seikyuCdTo3: "",
  seikyushitenCdTo3: "",
  seikyuNmrTo3: "",
  seikyuCdFrom4: "",
  seikyushitenCdFrom4: "",
  seikyuNmrFrom4: "",
  seikyuCdTo4: "",
  seikyushitenCdTo4: "",
  seikyuNmrTo4: "",
  seikyuCd1: "",
  seikyushitenCd1: "",
  seikyuNmr1: "",
  seikyuCd2: "",
  seikyushitenCd2: "",
  seikyuNmr2: "",
  seikyuCd3: "",
  seikyushitenCd3: "",
  seikyuNmr3: "",
  seikyuCd4: "",
  seikyushitenCd4: "",
  seikyuNmr4: "",
  seikyuCd5: "",
  seikyushitenCd5: "",
  seikyuNmr5: "",
  seikyuCd6: "",
  seikyushitenCd6: "",
  seikyuNmr6: "",
  seikyuCd7: "",
  seikyushitenCd7: "",
  seikyuNmr7: "",
  seikyuCd8: "",
  seikyushitenCd8: "",
  seikyuNmr8: "",
  seikyuCd9: "",
  seikyushitenCd9: "",
  seikyuNmr9: "",
  seikyuCd10: "",
  seikyushitenCd10: "",
  seikyuNmr10: "",
  seikyuCd11: "",
  seikyushitenCd11: "",
  seikyuNmr11: "",
  seikyuCd12: "",
  seikyushitenCd12: "",
  seikyuNmr12: "",
  seikyuCd13: "",
  seikyushitenCd13: "",
  seikyuNmr13: "",
  seikyuCd14: "",
  seikyushitenCd14: "",
  seikyuNmr14: "",
  seikyuCd15: "",
  seikyushitenCd15: "",
  seikyuNmr15: "",
  seikyuCd16: "",
  seikyushitenCd16: "",
  seikyuNmr16: "",
  seikyuCd17: "",
  seikyushitenCd17: "",
  seikyuNmr17: "",
  seikyuCd18: "",
  seikyushitenCd18: "",
  seikyuNmr18: "",
  seikyuCd19: "",
  seikyushitenCd19: "",
  seikyuNmr19: "",
  seikyuCd20: "",
  seikyushitenCd20: "",
  seikyuNmr20: "",
  taishoseikyuKensu: "",
  taishouridenpyoKensu: "",
  taishonyukindenpyoKensu: "",
  seikyushimeNo: "",
  seikyushimeshoriKbn: undefined,
  seikyushimeStatus: undefined,
};

const focusId = "B030010";

// B030010 請求締処理
export const B030010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // 遷移元データ取得用
  const location = useLocation();
  const inputData = location.state as B030010InputData;

  // 請求対象リストで全件が選択された場合
  const isZenken =
    methods.watch("seikyujokenKbn")?.value === seikyujokenKbn.zenken;

  // 検索条件セット
  // 初期表示イベント
  useEffect(() => {
    if (inputData === null) {
      // 検索ボタン活性化
      setDisabledSearch(false);
      return;
    }
    // 入力プロパティの反映
    const seikyu = inputData.seikyu;
    if (typeof seikyu === "undefined") return;
    // 請求データ設定
    methods.setValue("seikyuYmd", seikyu.seikyuYmd);
    methods.setValue("seikyushimeYmd", seikyu.seikyushimeYmd);
    methods.setValue("nyukinYmd", seikyu.nyukinYmd);
    methods.setValue("urikakeshainCd", seikyu.urikakeshainCd);
    methods.setValue("urikakeshainNm", seikyu.urikakeshainNm);
    methods.setValue(
      "seikyujokenKbn",
      getSCode(SeikyujokenKbn, seikyu.seikyujokenKbn)
    );
    methods.setValue("seikyuCdFrom1", seikyu.seikyucdFrom1);
    methods.setValue("seikyushitenCdFrom1", seikyu.seikyushitencdFrom1);
    methods.setValue("seikyuNmrFrom1", seikyu.seikyunmFrom1);
    methods.setValue("seikyuCdTo1", seikyu.seikyucdTo1);
    methods.setValue("seikyushitenCdTo1", seikyu.seikyushitencdTo1);
    methods.setValue("seikyuNmrTo1", seikyu.seikyunmTo1);
    methods.setValue("seikyuCdFrom2", seikyu.seikyucdFrom2);
    methods.setValue("seikyushitenCdFrom2", seikyu.seikyushitencdFrom2);
    methods.setValue("seikyuNmrFrom2", seikyu.seikyunmFrom2);
    methods.setValue("seikyuCdTo2", seikyu.seikyucdTo2);
    methods.setValue("seikyushitenCdTo2", seikyu.seikyushitencdTo2);
    methods.setValue("seikyuNmrTo2", seikyu.seikyunmTo2);
    methods.setValue("seikyuCdFrom3", seikyu.seikyucdFrom3);
    methods.setValue("seikyushitenCdFrom3", seikyu.seikyushitencdFrom3);
    methods.setValue("seikyuNmrFrom3", seikyu.seikyunmFrom3);
    methods.setValue("seikyuCdTo3", seikyu.seikyucdTo3);
    methods.setValue("seikyushitenCdTo3", seikyu.seikyushitencdTo3);
    methods.setValue("seikyuNmrTo3", seikyu.seikyunmTo3);
    methods.setValue("seikyuCdFrom4", seikyu.seikyucdFrom4);
    methods.setValue("seikyushitenCdFrom4", seikyu.seikyushitencdFrom4);
    methods.setValue("seikyuNmrFrom4", seikyu.seikyunmFrom4);
    methods.setValue("seikyuCdTo4", seikyu.seikyucdTo4);
    methods.setValue("seikyushitenCdTo4", seikyu.seikyushitencdTo4);
    methods.setValue("seikyuNmrTo4", seikyu.seikyunmTo4);
    methods.setValue("seikyuCd1", seikyu.seikyucd1);
    methods.setValue("seikyushitenCd1", seikyu.seikyushitencd1);
    methods.setValue("seikyuNmr1", seikyu.seikyunm1);
    methods.setValue("seikyuCd2", seikyu.seikyucd2);
    methods.setValue("seikyushitenCd2", seikyu.seikyushitencd2);
    methods.setValue("seikyuNmr2", seikyu.seikyunm2);
    methods.setValue("seikyuCd3", seikyu.seikyucd3);
    methods.setValue("seikyushitenCd3", seikyu.seikyushitencd3);
    methods.setValue("seikyuNmr3", seikyu.seikyunm3);
    methods.setValue("seikyuCd4", seikyu.seikyucd4);
    methods.setValue("seikyushitenCd4", seikyu.seikyushitencd4);
    methods.setValue("seikyuNmr4", seikyu.seikyunm4);
    methods.setValue("seikyuCd5", seikyu.seikyucd5);
    methods.setValue("seikyushitenCd5", seikyu.seikyushitencd5);
    methods.setValue("seikyuNmr5", seikyu.seikyunm5);
    methods.setValue("seikyuCd6", seikyu.seikyucd6);
    methods.setValue("seikyushitenCd6", seikyu.seikyushitencd6);
    methods.setValue("seikyuNmr6", seikyu.seikyunm6);
    methods.setValue("seikyuCd7", seikyu.seikyucd7);
    methods.setValue("seikyushitenCd7", seikyu.seikyushitencd7);
    methods.setValue("seikyuNmr7", seikyu.seikyunm7);
    methods.setValue("seikyuCd8", seikyu.seikyucd8);
    methods.setValue("seikyushitenCd8", seikyu.seikyushitencd8);
    methods.setValue("seikyuNmr8", seikyu.seikyunm8);
    methods.setValue("seikyuCd9", seikyu.seikyucd9);
    methods.setValue("seikyushitenCd9", seikyu.seikyushitencd9);
    methods.setValue("seikyuNmr9", seikyu.seikyunm9);
    methods.setValue("seikyuCd10", seikyu.seikyucd10);
    methods.setValue("seikyushitenCd10", seikyu.seikyushitencd10);
    methods.setValue("seikyuNmr10", seikyu.seikyunm10);
    methods.setValue("seikyuCd11", seikyu.seikyucd11);
    methods.setValue("seikyushitenCd11", seikyu.seikyushitencd11);
    methods.setValue("seikyuNmr11", seikyu.seikyunm11);
    methods.setValue("seikyuCd12", seikyu.seikyucd12);
    methods.setValue("seikyushitenCd12", seikyu.seikyushitencd12);
    methods.setValue("seikyuNmr12", seikyu.seikyunm12);
    methods.setValue("seikyuCd13", seikyu.seikyucd13);
    methods.setValue("seikyushitenCd13", seikyu.seikyushitencd13);
    methods.setValue("seikyuNmr13", seikyu.seikyunm13);
    methods.setValue("seikyuCd14", seikyu.seikyucd14);
    methods.setValue("seikyushitenCd14", seikyu.seikyushitencd14);
    methods.setValue("seikyuNmr14", seikyu.seikyunm14);
    methods.setValue("seikyuCd15", seikyu.seikyucd15);
    methods.setValue("seikyushitenCd15", seikyu.seikyushitencd15);
    methods.setValue("seikyuNmr15", seikyu.seikyunm15);
    methods.setValue("seikyuCd16", seikyu.seikyucd16);
    methods.setValue("seikyushitenCd16", seikyu.seikyushitencd16);
    methods.setValue("seikyuNmr16", seikyu.seikyunm16);
    methods.setValue("seikyuCd17", seikyu.seikyucd17);
    methods.setValue("seikyushitenCd17", seikyu.seikyushitencd17);
    methods.setValue("seikyuNmr17", seikyu.seikyunm17);
    methods.setValue("seikyuCd18", seikyu.seikyucd18);
    methods.setValue("seikyushitenCd18", seikyu.seikyushitencd18);
    methods.setValue("seikyuNmr18", seikyu.seikyunm18);
    methods.setValue("seikyuCd19", seikyu.seikyucd19);
    methods.setValue("seikyushitenCd19", seikyu.seikyushitencd19);
    methods.setValue("seikyuNmr19", seikyu.seikyunm19);
    methods.setValue("seikyuCd20", seikyu.seikyucd20);
    methods.setValue("seikyushitenCd20", seikyu.seikyushitencd20);
    methods.setValue("seikyuNmr20", seikyu.seikyunm20);
    methods.setValue("taishoseikyuKensu", seikyu.taishoseikyuKensu);
    methods.setValue("taishouridenpyoKensu", seikyu.taishouridenpyoKensu);
    methods.setValue("taishonyukindenpyoKensu", seikyu.taishonyukindenpyoKensu);
    methods.setValue("seikyushimeNo", seikyu.seikyushimeNo);
    methods.setValue("seikyushimeshoriKbn", seikyu.seikyushimeshoriKbn);
    methods.setValue("seikyushimeStatus", seikyu.seikyushimeStatus);

    // 検索ボタン活性化
    setDisabledSearch(false);
    // 締処理キャンセルボタン活性化
    setDisabledCansel(false);
  }, []);

  // 初期表示(共通)
  useEffect(() => {
    if (inputData !== null) {
      return;
    }
    focus(1);
    // 検索ボタン活性化
    setDisabledSearch(false);
    // 締処理キャンセルボタン活性化
    setDisabledCansel(false);
  });

  // ボタンの活性・非活性
  const [disabledRun, setDisabledRun] = useState(true);
  const [disabledCansel, setDisabledCansel] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();

  // 検索ボタンクリックイベント
  const handleClickSearchButtun = () => {
    return new Promise<any>(() => {
      // リクエスト作成
      // 検索フォームのデータを取得する。
      const fields = methods.getValues();
      // 検索クリックイベント
      const param: B030010FindRequest = {
        seikyuYmd: fields.seikyuYmd!,
        seikyushimeYmd: fields.seikyushimeYmd!,
        nyukinYmd: fields.nyukinYmd!,
        seikyujokenKbn: fields.seikyujokenKbn?.value!,
        urikakeshainCd: fields.urikakeshainCd,
        seikyucdFrom1: fields.seikyuCdFrom1,
        seikyushitencdFrom1: fields.seikyushitenCdFrom1,
        seikyucdTo1: fields.seikyuCdTo1,
        seikyushitencdTo1: fields.seikyushitenCdTo1,
        seikyucdFrom2: fields.seikyuCdFrom2,
        seikyushitencdFrom2: fields.seikyushitenCdFrom2,
        seikyucdTo2: fields.seikyuCdTo2,
        seikyushitencdTo2: fields.seikyushitenCdTo2,
        seikyucdFrom3: fields.seikyuCdFrom3,
        seikyushitencdFrom3: fields.seikyushitenCdFrom3,
        seikyucdTo3: fields.seikyuCdTo3,
        seikyushitencdTo3: fields.seikyushitenCdTo3,
        seikyucdFrom4: fields.seikyuCdFrom4,
        seikyushitencdFrom4: fields.seikyushitenCdFrom4,
        seikyucdTo4: fields.seikyuCdTo4,
        seikyushitencdTo4: fields.seikyushitenCdTo4,
        seikyucd1: fields.seikyuCd1,
        seikyushitencd1: fields.seikyushitenCd1,
        seikyucd2: fields.seikyuCd2,
        seikyushitencd2: fields.seikyushitenCd2,
        seikyucd3: fields.seikyuCd3,
        seikyushitencd3: fields.seikyushitenCd3,
        seikyucd4: fields.seikyuCd4,
        seikyushitencd4: fields.seikyushitenCd4,
        seikyucd5: fields.seikyuCd5,
        seikyushitencd5: fields.seikyushitenCd5,
        seikyucd6: fields.seikyuCd6,
        seikyushitencd6: fields.seikyushitenCd6,
        seikyucd7: fields.seikyuCd7,
        seikyushitencd7: fields.seikyushitenCd7,
        seikyucd8: fields.seikyuCd8,
        seikyushitencd8: fields.seikyushitenCd8,
        seikyucd9: fields.seikyuCd9,
        seikyushitencd9: fields.seikyushitenCd9,
        seikyucd10: fields.seikyuCd10,
        seikyushitencd10: fields.seikyushitenCd10,
        seikyucd11: fields.seikyuCd11,
        seikyushitencd11: fields.seikyushitenCd11,
        seikyucd12: fields.seikyuCd12,
        seikyushitencd12: fields.seikyushitenCd12,
        seikyucd13: fields.seikyuCd13,
        seikyushitencd13: fields.seikyushitenCd13,
        seikyucd14: fields.seikyuCd14,
        seikyushitencd14: fields.seikyushitenCd14,
        seikyucd15: fields.seikyuCd15,
        seikyushitencd15: fields.seikyushitenCd15,
        seikyucd16: fields.seikyuCd16,
        seikyushitencd16: fields.seikyushitenCd16,
        seikyucd17: fields.seikyuCd17,
        seikyushitencd17: fields.seikyushitenCd17,
        seikyucd18: fields.seikyuCd18,
        seikyushitencd18: fields.seikyushitenCd18,
        seikyucd19: fields.seikyuCd19,
        seikyushitencd19: fields.seikyushitenCd19,
        seikyucd20: fields.seikyuCd20,
        seikyushitencd20: fields.seikyushitenCd20,
      };
      // API呼び出し
      B030010Find(param)
        // 正常取得時
        .then((value) => {
          // 件数の設定
          handleKensu(value.data);
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          // エラー時は件数をクリアする。
          methods.setValue("taishoseikyuKensu", "");
          methods.setValue("taishouridenpyoKensu", "");
          methods.setValue("taishonyukindenpyoKensu", "");
          // ボタン非活性化
          setDisabledRun(true);
        });
    });
  };

  // 件数の設定
  const handleKensu = (data: B030010FindResponse) => {
    // 検索結果のチェック
    // 対象請求先件数が 0 件の場合
    if (Number(data.taishoseikyuKensu) === 0) {
      // 件数の設定
      methods.setValue("taishoseikyuKensu", data.taishoseikyuKensu);
      methods.setValue("taishouridenpyoKensu", data.taishouridenpyoKensu);
      methods.setValue("taishonyukindenpyoKensu", data.taishonyukindenpyoKensu);

      // 締処理実行ボタン非活性化
      setDisabledRun(true);
    }
    // 対象請求先件数が 1 件以上の場合
    else if (Number(data.taishoseikyuKensu) >= 1) {
      // 件数の設定
      methods.setValue("taishoseikyuKensu", data.taishoseikyuKensu);
      methods.setValue("taishouridenpyoKensu", data.taishouridenpyoKensu);
      methods.setValue("taishonyukindenpyoKensu", data.taishonyukindenpyoKensu);

      // 締処理実行ボタン活性化
      setDisabledRun(false);
    }
  };

  // 請求締処理実行イベント
  const handleClickRunButtun = () => {
    const data = methods.getValues();
    // パラメータ作成
    const param: B030010CreateRequest = {
      seikyuYmd: data.seikyuYmd!,
      seikyushimeYmd: data.seikyushimeYmd!,
      nyukinYmd: data.nyukinYmd!,
      seikyujokenKbn: data.seikyujokenKbn?.value!,
      taishoseikyuKensu: data.taishoseikyuKensu!,
      taishouridenpyoKensu: data.taishouridenpyoKensu!,
      taishonyukindenpyoKensu: data.taishonyukindenpyoKensu!,
      urikakeshainCd: data.urikakeshainCd,
      seikyucdFrom1: data.seikyuCdFrom1,
      seikyushitencdFrom1: data.seikyushitenCdFrom1,
      seikyucdTo1: data.seikyuCdTo1,
      seikyushitencdTo1: data.seikyushitenCdTo1,
      seikyucdFrom2: data.seikyuCdFrom2,
      seikyushitencdFrom2: data.seikyushitenCdFrom2,
      seikyucdTo2: data.seikyuCdTo2,
      seikyushitencdTo2: data.seikyushitenCdTo2,
      seikyucdFrom3: data.seikyuCdFrom3,
      seikyushitencdFrom3: data.seikyushitenCdFrom3,
      seikyucdTo3: data.seikyuCdTo3,
      seikyushitencdTo3: data.seikyushitenCdTo3,
      seikyucdFrom4: data.seikyuCdFrom4,
      seikyushitencdFrom4: data.seikyushitenCdFrom4,
      seikyucdTo4: data.seikyuCdTo4,
      seikyushitencdTo4: data.seikyushitenCdTo4,
      seikyucd1: data.seikyuCd1,
      seikyushitencd1: data.seikyushitenCd1,
      seikyucd2: data.seikyuCd2,
      seikyushitencd2: data.seikyushitenCd2,
      seikyucd3: data.seikyuCd3,
      seikyushitencd3: data.seikyushitenCd3,
      seikyucd4: data.seikyuCd4,
      seikyushitencd4: data.seikyushitenCd4,
      seikyucd5: data.seikyuCd5,
      seikyushitencd5: data.seikyushitenCd5,
      seikyucd6: data.seikyuCd6,
      seikyushitencd6: data.seikyushitenCd6,
      seikyucd7: data.seikyuCd7,
      seikyushitencd7: data.seikyushitenCd7,
      seikyucd8: data.seikyuCd8,
      seikyushitencd8: data.seikyushitenCd8,
      seikyucd9: data.seikyuCd9,
      seikyushitencd9: data.seikyushitenCd9,
      seikyucd10: data.seikyuCd10,
      seikyushitencd10: data.seikyushitenCd10,
      seikyucd11: data.seikyuCd11,
      seikyushitencd11: data.seikyushitenCd11,
      seikyucd12: data.seikyuCd12,
      seikyushitencd12: data.seikyushitenCd12,
      seikyucd13: data.seikyuCd13,
      seikyushitencd13: data.seikyushitenCd13,
      seikyucd14: data.seikyuCd14,
      seikyushitencd14: data.seikyushitenCd14,
      seikyucd15: data.seikyuCd15,
      seikyushitencd15: data.seikyushitenCd15,
      seikyucd16: data.seikyuCd16,
      seikyushitencd16: data.seikyushitenCd16,
      seikyucd17: data.seikyuCd17,
      seikyushitencd17: data.seikyushitenCd17,
      seikyucd18: data.seikyuCd18,
      seikyushitencd18: data.seikyushitenCd18,
      seikyucd19: data.seikyuCd19,
      seikyushitencd19: data.seikyushitenCd19,
      seikyucd20: data.seikyuCd20,
      seikyushitencd20: data.seikyushitenCd20,
    };

    // 実行API呼び出し
    B030010Create(param)
      .then(() => {
        setMsg(getClientMessage("B030010_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 請求締処理キャンセルイベント
  const handleClickCancelButtun = () => {
    // リクエスト作成
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();
    // パラメータ作成
    const param: B030010UpdateRequest = {
      seikyushimeYmd: fields.seikyushimeYmd!,
      seikyujokenKbn: fields.seikyujokenKbn?.value!,
      urikakeshainCd: fields.urikakeshainCd,
      seikyucdFrom1: fields.seikyuCdFrom1,
      seikyushitencdFrom1: fields.seikyushitenCdFrom1,
      seikyucdTo1: fields.seikyuCdTo1,
      seikyushitencdTo1: fields.seikyushitenCdTo1,
      seikyucdFrom2: fields.seikyuCdFrom2,
      seikyushitencdFrom2: fields.seikyushitenCdFrom2,
      seikyucdTo2: fields.seikyuCdTo2,
      seikyushitencdTo2: fields.seikyushitenCdTo2,
      seikyucdFrom3: fields.seikyuCdFrom3,
      seikyushitencdFrom3: fields.seikyushitenCdFrom3,
      seikyucdTo3: fields.seikyuCdTo3,
      seikyushitencdTo3: fields.seikyushitenCdTo3,
      seikyucdFrom4: fields.seikyuCdFrom4,
      seikyushitencdFrom4: fields.seikyushitenCdFrom4,
      seikyucdTo4: fields.seikyuCdTo4,
      seikyushitencdTo4: fields.seikyushitenCdTo4,
      seikyucd1: fields.seikyuCd1,
      seikyushitencd1: fields.seikyushitenCd1,
      seikyucd2: fields.seikyuCd2,
      seikyushitencd2: fields.seikyushitenCd2,
      seikyucd3: fields.seikyuCd3,
      seikyushitencd3: fields.seikyushitenCd3,
      seikyucd4: fields.seikyuCd4,
      seikyushitencd4: fields.seikyushitenCd4,
      seikyucd5: fields.seikyuCd5,
      seikyushitencd5: fields.seikyushitenCd5,
      seikyucd6: fields.seikyuCd6,
      seikyushitencd6: fields.seikyushitenCd6,
      seikyucd7: fields.seikyuCd7,
      seikyushitencd7: fields.seikyushitenCd7,
      seikyucd8: fields.seikyuCd8,
      seikyushitencd8: fields.seikyushitenCd8,
      seikyucd9: fields.seikyuCd9,
      seikyushitencd9: fields.seikyushitenCd9,
      seikyucd10: fields.seikyuCd10,
      seikyushitencd10: fields.seikyushitenCd10,
      seikyucd11: fields.seikyuCd11,
      seikyushitencd11: fields.seikyushitenCd11,
      seikyucd12: fields.seikyuCd12,
      seikyushitencd12: fields.seikyushitenCd12,
      seikyucd13: fields.seikyuCd13,
      seikyushitencd13: fields.seikyushitenCd13,
      seikyucd14: fields.seikyuCd14,
      seikyushitencd14: fields.seikyushitenCd14,
      seikyucd15: fields.seikyuCd15,
      seikyushitencd15: fields.seikyushitenCd15,
      seikyucd16: fields.seikyuCd16,
      seikyushitencd16: fields.seikyushitenCd16,
      seikyucd17: fields.seikyuCd17,
      seikyushitencd17: fields.seikyushitenCd17,
      seikyucd18: fields.seikyuCd18,
      seikyushitencd18: fields.seikyushitenCd18,
      seikyucd19: fields.seikyuCd19,
      seikyushitencd19: fields.seikyushitenCd19,
      seikyucd20: fields.seikyuCd20,
      seikyushitencd20: fields.seikyushitenCd20,
    };
    // キャンセルAPI呼び出し
    B030010Update(param)
      .then(() => {
        setMsg(getClientMessage("B030010_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="請求締処理"
          gridTemplateColumns="7rem 2rem 7rem 6rem 11rem 2rem 7rem 6rem 11rem"
        >
          <SLabel required gridColumn="span 2">
            請求日
          </SLabel>
          <SDateField
            name="seikyuYmd"
            label="請求日"
            required
            gridColumn="span 2"
            {...register(1)}
          />

          <SText gridColumn="span 3" color="red">
            ※検索、締処理実行時のみ必須です。
          </SText>

          <Box gridColumn="span 2" />

          <SLabel required gridColumn="span 2">
            請求締日
          </SLabel>
          <SDateField
            name="seikyushimeYmd"
            label="請求締日"
            required
            gridColumn="span 2"
            {...register(2)}
          />

          <Box gridColumn="span 5" />

          <SLabel required gridColumn="span 2">
            入金対象日
          </SLabel>
          <SDateField
            name="nyukinYmd"
            label="入金対象日"
            required
            gridColumn="span 2"
            {...register(3)}
          />

          <SText gridColumn="span 3" color="red">
            ※検索、締処理実行時のみ必須です。
          </SText>

          <Box gridColumn="span 2" />

          <SLabel gridColumn="span 2">売掛担当者</SLabel>
          <SNumberField
            name="urikakeshainCd"
            label="売掛担当者コード"
            code
            size={7}
            gridColumn="span 2"
            onBlur={() => B000140UrikakeshainNm(methods, navigate, setMsg)}
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("urikakeshainCd", data.shainCd);
              methods.setValue("urikakeshainNm", data.shainNm);
            }}
            {...register(4)}
          />
          <STextField name="urikakeshainNm" label="売掛担当者名" disabled />

          <Box gridColumn="span 4" />

          <SLabel required gridColumn="span 2">
            請求対象
          </SLabel>
          <SCodeSelect
            name="seikyujokenKbn"
            label="請求対象"
            required
            options={SeikyujokenKbn}
            gridColumn="span 2"
            {...register(5)}
          />

          <SText gridColumn="1">　</SText>

          <SLabel gridColumn="1" gridRow="span 4">
            請求範囲指定
          </SLabel>
          <SLabel>1</SLabel>
          <SNumberField
            name="seikyuCdFrom1"
            label="請求先コードの範囲(開始)1"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrFrom1(methods, navigate, setMsg)}
            {...register(6)}
          />
          <SNumberField
            name="seikyushitenCdFrom1"
            label="請求先支店コードの範囲(開始)1"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdFrom1", data.tokuiCd);
              methods.setValue("seikyushitenCdFrom1", data.tokuishitenCd);
              methods.setValue("seikyuNmrFrom1", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrFrom1(methods, navigate, setMsg)}
            {...register(7)}
          />
          <STextField
            name="seikyuNmrFrom1"
            label="請求先名の範囲(開始)1"
            size={24}
            disabled
          />
          <SText>～</SText>
          <SNumberField
            name="seikyuCdTo1"
            label="請求先コードの範囲(終了)1"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrTo1(methods, navigate, setMsg)}
            {...register(8)}
          />
          <SNumberField
            name="seikyushitenCdTo1"
            label="請求先コードの範囲(終了)1"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdTo1", data.tokuiCd);
              methods.setValue("seikyushitenCdTo1", data.tokuishitenCd);
              methods.setValue("seikyuNmrTo1", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrTo1(methods, navigate, setMsg)}
            {...register(9)}
          />
          <STextField
            name="seikyuNmrTo1"
            label="請求先支店コードの範囲(終了)1"
            size={24}
            disabled
          />

          <SLabel>2</SLabel>
          <SNumberField
            name="seikyuCdFrom2"
            label="請求先コードの範囲(開始)2"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrFrom2(methods, navigate, setMsg)}
            {...register(10)}
          />
          <SNumberField
            name="seikyushitenCdFrom2"
            label="請求先支店コードの範囲(開始)2"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdFrom2", data.tokuiCd);
              methods.setValue("seikyushitenCdFrom2", data.tokuishitenCd);
              methods.setValue("seikyuNmrFrom2", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrFrom2(methods, navigate, setMsg)}
            {...register(11)}
          />
          <STextField
            name="seikyuNmrFrom2"
            label="請求先名の範囲(開始)2"
            size={24}
            disabled
          />
          <SText>～</SText>
          <SNumberField
            name="seikyuCdTo2"
            label="請求先コードの範囲(終了)2"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrTo2(methods, navigate, setMsg)}
            {...register(12)}
          />
          <SNumberField
            name="seikyushitenCdTo2"
            label="請求先コードの範囲(終了)2"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdTo2", data.tokuiCd);
              methods.setValue("seikyushitenCdTo2", data.tokuishitenCd);
              methods.setValue("seikyuNmrTo2", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrTo2(methods, navigate, setMsg)}
            {...register(13)}
          />
          <STextField
            name="seikyuNmrTo2"
            label="請求先支店コードの範囲(終了)2"
            size={24}
            disabled
          />

          <SLabel>3</SLabel>
          <SNumberField
            name="seikyuCdFrom3"
            label="請求先コードの範囲(開始)3"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrFrom3(methods, navigate, setMsg)}
            {...register(14)}
          />
          <SNumberField
            name="seikyushitenCdFrom3"
            label="請求先支店コードの範囲(開始)3"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdFrom3", data.tokuiCd);
              methods.setValue("seikyushitenCdFrom3", data.tokuishitenCd);
              methods.setValue("seikyuNmrFrom3", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrFrom3(methods, navigate, setMsg)}
            {...register(15)}
          />
          <STextField
            name="seikyuNmrFrom3"
            label="請求先名の範囲(開始)3"
            size={24}
            disabled
          />
          <SText>～</SText>
          <SNumberField
            name="seikyuCdTo3"
            label="請求先コードの範囲(終了)3"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrTo3(methods, navigate, setMsg)}
            {...register(16)}
          />
          <SNumberField
            name="seikyushitenCdTo3"
            label="請求先コードの範囲(終了)3"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdTo3", data.tokuiCd);
              methods.setValue("seikyushitenCdTo3", data.tokuishitenCd);
              methods.setValue("seikyuNmrTo3", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrTo3(methods, navigate, setMsg)}
            {...register(17)}
          />
          <STextField
            name="seikyuNmrTo3"
            label="請求先支店コードの範囲(終了)3"
            size={24}
            disabled
          />

          <SLabel>4</SLabel>
          <SNumberField
            name="seikyuCdFrom4"
            label="請求先コードの範囲(開始)4"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrFrom4(methods, navigate, setMsg)}
            {...register(18)}
          />
          <SNumberField
            name="seikyushitenCdFrom4"
            label="請求先支店コードの範囲(開始)4"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdFrom4", data.tokuiCd);
              methods.setValue("seikyushitenCdFrom4", data.tokuishitenCd);
              methods.setValue("seikyuNmrFrom4", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrFrom4(methods, navigate, setMsg)}
            {...register(19)}
          />
          <STextField
            name="seikyuNmrFrom4"
            label="請求先名の範囲(開始)4"
            size={24}
            disabled
          />
          <SText>～</SText>
          <SNumberField
            name="seikyuCdTo4"
            label="請求先コードの範囲(終了)4"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmrTo4(methods, navigate, setMsg)}
            {...register(20)}
          />
          <SNumberField
            name="seikyushitenCdTo4"
            label="請求先コードの範囲(終了)4"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCdTo4", data.tokuiCd);
              methods.setValue("seikyushitenCdTo4", data.tokuishitenCd);
              methods.setValue("seikyuNmrTo4", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmrTo4(methods, navigate, setMsg)}
            {...register(21)}
          />
          <STextField
            name="seikyuNmrTo4"
            label="請求先支店コードの範囲(終了)4"
            size={24}
            disabled
          />

          <SLabel gridColumn="1" gridRow="span 10">
            個別請求先
          </SLabel>
          <SLabel>1</SLabel>
          <SNumberField
            name="seikyuCd1"
            label="請求先コード1"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr1(methods, navigate, setMsg)}
            {...register(22)}
          />
          <SNumberField
            name="seikyushitenCd1"
            label="請求先支店コード1"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd1", data.tokuiCd);
              methods.setValue("seikyushitenCd1", data.tokuishitenCd);
              methods.setValue("seikyuNmr1", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr1(methods, navigate, setMsg)}
            {...register(23)}
          />
          <STextField
            name="seikyuNmr1"
            label="請求先名略1"
            size={24}
            disabled
          />

          <SLabel>11</SLabel>
          <SNumberField
            name="seikyuCd11"
            label="請求先コード11"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr11(methods, navigate, setMsg)}
            {...register(42)}
          />
          <SNumberField
            name="seikyushitenCd11"
            label="請求先支店コード11"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd11", data.tokuiCd);
              methods.setValue("seikyushitenCd11", data.tokuishitenCd);
              methods.setValue("seikyuNmr11", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr11(methods, navigate, setMsg)}
            {...register(43)}
          />
          <STextField
            name="seikyuNmr11"
            label="請求先名略11"
            size={24}
            disabled
          />

          <SLabel>2</SLabel>
          <SNumberField
            name="seikyuCd2"
            label="請求先コード2"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr2(methods, navigate, setMsg)}
            {...register(24)}
          />
          <SNumberField
            name="seikyushitenCd2"
            label="請求先支店コード2"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd2", data.tokuiCd);
              methods.setValue("seikyushitenCd2", data.tokuishitenCd);
              methods.setValue("seikyuNmr2", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr2(methods, navigate, setMsg)}
            {...register(25)}
          />
          <STextField
            name="seikyuNmr2"
            label="請求先名略2"
            size={24}
            disabled
          />

          <SLabel>12</SLabel>
          <SNumberField
            name="seikyuCd12"
            label="請求先コード12"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr12(methods, navigate, setMsg)}
            {...register(44)}
          />
          <SNumberField
            name="seikyushitenCd12"
            label="請求先支店コード12"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd12", data.tokuiCd);
              methods.setValue("seikyushitenCd12", data.tokuishitenCd);
              methods.setValue("seikyuNmr12", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr12(methods, navigate, setMsg)}
            {...register(45)}
          />
          <STextField
            name="seikyuNmr12"
            label="請求先名略12"
            size={24}
            disabled
          />

          <SLabel>3</SLabel>
          <SNumberField
            name="seikyuCd3"
            label="請求先コード3"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr3(methods, navigate, setMsg)}
            {...register(26)}
          />
          <SNumberField
            name="seikyushitenCd3"
            label="請求先支店コード3"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd3", data.tokuiCd);
              methods.setValue("seikyushitenCd3", data.tokuishitenCd);
              methods.setValue("seikyuNmr3", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr3(methods, navigate, setMsg)}
            {...register(27)}
          />
          <STextField
            name="seikyuNmr3"
            label="請求先名略3"
            size={24}
            disabled
          />

          <SLabel>13</SLabel>
          <SNumberField
            name="seikyuCd13"
            label="請求先コード13"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr13(methods, navigate, setMsg)}
            {...register(46)}
          />
          <SNumberField
            name="seikyushitenCd13"
            label="請求先支店コード13"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd13", data.tokuiCd);
              methods.setValue("seikyushitenCd13", data.tokuishitenCd);
              methods.setValue("seikyuNmr13", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr13(methods, navigate, setMsg)}
            {...register(47)}
          />
          <STextField
            name="seikyuNmr13"
            label="請求先名略13"
            size={24}
            disabled
          />

          <SLabel>4</SLabel>
          <SNumberField
            name="seikyuCd4"
            label="請求先コード4"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr4(methods, navigate, setMsg)}
            {...register(28)}
          />
          <SNumberField
            name="seikyushitenCd4"
            label="請求先支店コード4"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd4", data.tokuiCd);
              methods.setValue("seikyushitenCd4", data.tokuishitenCd);
              methods.setValue("seikyuNmr4", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr4(methods, navigate, setMsg)}
            {...register(29)}
          />
          <STextField
            name="seikyuNmr4"
            label="請求先名略4"
            size={24}
            disabled
          />

          <SLabel>14</SLabel>
          <SNumberField
            name="seikyuCd14"
            label="請求先コード14"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr14(methods, navigate, setMsg)}
            {...register(48)}
          />
          <SNumberField
            name="seikyushitenCd14"
            label="請求先支店コード14"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd14", data.tokuiCd);
              methods.setValue("seikyushitenCd14", data.tokuishitenCd);
              methods.setValue("seikyuNmr14", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr14(methods, navigate, setMsg)}
            {...register(49)}
          />
          <STextField
            name="seikyuNmr14"
            label="請求先名略14"
            size={24}
            disabled
          />

          <SLabel>5</SLabel>
          <SNumberField
            name="seikyuCd5"
            label="請求先コード5"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr5(methods, navigate, setMsg)}
            {...register(30)}
          />
          <SNumberField
            name="seikyushitenCd5"
            label="請求先支店コード5"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd5", data.tokuiCd);
              methods.setValue("seikyushitenCd5", data.tokuishitenCd);
              methods.setValue("seikyuNmr5", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr5(methods, navigate, setMsg)}
            {...register(31)}
          />
          <STextField
            name="seikyuNmr5"
            label="請求先名略5"
            size={24}
            disabled
          />

          <SLabel>15</SLabel>
          <SNumberField
            name="seikyuCd15"
            label="請求先コード15"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr15(methods, navigate, setMsg)}
            {...register(50)}
          />
          <SNumberField
            name="seikyushitenCd15"
            label="請求先支店コード15"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd15", data.tokuiCd);
              methods.setValue("seikyushitenCd15", data.tokuishitenCd);
              methods.setValue("seikyuNmr15", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr15(methods, navigate, setMsg)}
            {...register(51)}
          />
          <STextField
            name="seikyuNmr15"
            label="請求先名略15"
            size={24}
            disabled
          />

          <SLabel>6</SLabel>
          <SNumberField
            name="seikyuCd6"
            label="請求先コード6"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr6(methods, navigate, setMsg)}
            {...register(32)}
          />
          <SNumberField
            name="seikyushitenCd6"
            label="請求先支店コード6"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd6", data.tokuiCd);
              methods.setValue("seikyushitenCd6", data.tokuishitenCd);
              methods.setValue("seikyuNmr6", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr6(methods, navigate, setMsg)}
            {...register(33)}
          />
          <STextField
            name="seikyuNmr6"
            label="請求先名略6"
            size={24}
            disabled
          />

          <SLabel>16</SLabel>
          <SNumberField
            name="seikyuCd16"
            label="請求先コード16"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr16(methods, navigate, setMsg)}
            {...register(52)}
          />
          <SNumberField
            name="seikyushitenCd16"
            label="請求先支店コード16"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd16", data.tokuiCd);
              methods.setValue("seikyushitenCd16", data.tokuishitenCd);
              methods.setValue("seikyuNmr16", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr16(methods, navigate, setMsg)}
            {...register(53)}
          />
          <STextField
            name="seikyuNmr16"
            label="請求先名略16"
            size={24}
            disabled
          />

          <SLabel>7</SLabel>
          <SNumberField
            name="seikyuCd7"
            label="請求先コード7"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr7(methods, navigate, setMsg)}
            {...register(34)}
          />
          <SNumberField
            name="seikyushitenCd7"
            label="請求先支店コード7"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd7", data.tokuiCd);
              methods.setValue("seikyushitenCd7", data.tokuishitenCd);
              methods.setValue("seikyuNmr7", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr7(methods, navigate, setMsg)}
            {...register(35)}
          />
          <STextField
            name="seikyuNmr7"
            label="請求先名略7"
            size={24}
            disabled
          />

          <SLabel>17</SLabel>
          <SNumberField
            name="seikyuCd17"
            label="請求先コード17"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr17(methods, navigate, setMsg)}
            {...register(54)}
          />
          <SNumberField
            name="seikyushitenCd17"
            label="請求先支店コード17"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd17", data.tokuiCd);
              methods.setValue("seikyushitenCd17", data.tokuishitenCd);
              methods.setValue("seikyuNmr17", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr17(methods, navigate, setMsg)}
            {...register(55)}
          />
          <STextField
            name="seikyuNmr17"
            label="請求先名略17"
            size={24}
            disabled
          />

          <SLabel>8</SLabel>
          <SNumberField
            name="seikyuCd8"
            label="請求先コード8"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr8(methods, navigate, setMsg)}
            {...register(36)}
          />
          <SNumberField
            name="seikyushitenCd8"
            label="請求先支店コード8"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd8", data.tokuiCd);
              methods.setValue("seikyushitenCd8", data.tokuishitenCd);
              methods.setValue("seikyuNmr8", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr8(methods, navigate, setMsg)}
            {...register(37)}
          />
          <STextField
            name="seikyuNmr8"
            label="請求先名略8"
            size={24}
            disabled
          />

          <SLabel>18</SLabel>
          <SNumberField
            name="seikyuCd18"
            label="請求先コード18"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr18(methods, navigate, setMsg)}
            {...register(56)}
          />
          <SNumberField
            name="seikyushitenCd18"
            label="請求先支店コード18"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd18", data.tokuiCd);
              methods.setValue("seikyushitenCd18", data.tokuishitenCd);
              methods.setValue("seikyuNmr18", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr18(methods, navigate, setMsg)}
            {...register(57)}
          />
          <STextField
            name="seikyuNmr18"
            label="請求先名略18"
            size={24}
            disabled
          />

          <SLabel>9</SLabel>
          <SNumberField
            name="seikyuCd9"
            label="請求先コード9"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr9(methods, navigate, setMsg)}
            {...register(38)}
          />
          <SNumberField
            name="seikyushitenCd9"
            label="請求先支店コード9"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd9", data.tokuiCd);
              methods.setValue("seikyushitenCd9", data.tokuishitenCd);
              methods.setValue("seikyuNmr9", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr9(methods, navigate, setMsg)}
            {...register(39)}
          />
          <STextField
            name="seikyuNmr9"
            label="請求先名略9"
            size={24}
            disabled
          />

          <SLabel>19</SLabel>
          <SNumberField
            name="seikyuCd19"
            label="請求先コード19"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr19(methods, navigate, setMsg)}
            {...register(58)}
          />
          <SNumberField
            name="seikyushitenCd19"
            label="請求先支店コード19"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd19", data.tokuiCd);
              methods.setValue("seikyushitenCd19", data.tokuishitenCd);
              methods.setValue("seikyuNmr19", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr19(methods, navigate, setMsg)}
            {...register(59)}
          />
          <STextField
            name="seikyuNmr19"
            label="請求先名略19"
            size={24}
            disabled
          />

          <SLabel>10</SLabel>
          <SNumberField
            name="seikyuCd10"
            label="請求先コード10"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr10(methods, navigate, setMsg)}
            {...register(40)}
          />
          <SNumberField
            name="seikyushitenCd10"
            label="請求先支店コード10"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd10", data.tokuiCd);
              methods.setValue("seikyushitenCd10", data.tokuishitenCd);
              methods.setValue("seikyuNmr10", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr10(methods, navigate, setMsg)}
            {...register(41)}
          />
          <STextField
            name="seikyuNmr10"
            label="請求先名略10"
            size={24}
            disabled
          />

          <SLabel>20</SLabel>
          <SNumberField
            name="seikyuCd20"
            label="請求先コード20"
            code
            disabled={isZenken}
            size={6}
            onBlur={() => B000150SeikyuNmr20(methods, navigate, setMsg)}
            {...register(60)}
          />
          <SNumberField
            name="seikyushitenCd20"
            label="請求先支店コード20"
            code
            disabled={isZenken}
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd20", data.tokuiCd);
              methods.setValue("seikyushitenCd20", data.tokuishitenCd);
              methods.setValue("seikyuNmr20", data.tokuiNmr);
            }}
            onBlur={() => B000150SeikyuNmr20(methods, navigate, setMsg)}
            {...register(61)}
          />
          <STextField
            name="seikyuNmr20"
            label="請求先名略20"
            size={24}
            disabled
          />

          <Box gridColumn="span 8" />

          <SNormalButton
            label={labels.buttons.search}
            align="right"
            {...register(62)}
            onClick={handleClickSearchButtun}
            disabled={disabledSearch}
          />
        </SFrame>
        <SFrame gridTemplateColumns="8rem 8rem 16rem 8rem 8rem 9rem">
          <SLabel>対象請求先件数</SLabel>
          <SNumberField
            name="taishoseikyuKensu"
            label="対象請求先件数"
            disabled
            align="right"
          />

          <SLabel gridColumn="4">対象売上伝票件数</SLabel>
          <SNumberField
            name="taishouridenpyoKensu"
            label="対象売上伝票件数"
            disabled
            align="right"
          />

          <Box gridColumn="span 2" />

          <SLabel gridColumn="4">対象入金伝票件数</SLabel>
          <SNumberField
            name="taishonyukindenpyoKensu"
            label="対象入金伝票件数"
            disabled
            align="right"
          />

          <SCancelButton
            label={labels.buttons.clampingcancel}
            align="left"
            {...register(63)}
            disabled={disabledCansel}
            onClick={handleClickCancelButtun}
            gridColumn="1"
            gridRow="3"
          />

          <SNormalButton
            label={labels.buttons.clampingrun}
            align="right"
            {...register(64)}
            disabled={disabledRun}
            onClick={handleClickRunButtun}
            gridColumn="6"
            gridRow="3"
          />
        </SFrame>
      </FormProvider>
    </>
  );
};
